module.exports = __webpack_public_path__ + "static/040-9438a6dbad4c785dc21cec1558523cd3.jpg";